import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import * as React from "react";
import {useContext} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {
    POI_TYPE_TEMPLATE_ASSISTANCE,
    POI_TYPE_TEMPLATE_DMS,
    POI_TYPE_TEMPLATE_EPLUS
} from "../../../component/Constants";
import {useStatusValuesPoi} from "../../../component/useStatusValuesPoi";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";


const PoiDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'poi'});

    const {globalData} = useContext(GlobalContext);

    const {getStatusLabelPoi} = useStatusValuesPoi();
    const theme = useTheme();
    const {poi, services} = props;

    return (
        poi &&
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('details') + ' ' + poi?.name}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container rowSpacing={3} columnSpacing={3}>
                    <UserLegalEntitiesOrDealersInputGroup tenantId={poi.tenantId} dealerId={poi.dealerId}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('id')}
                            value={poi.id}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('status')}
                            value={getStatusLabelPoi(poi.status)}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('service')}
                            value={services.length > 0 && poi.idPoiServiceList.length > 0 ? services.filter((s: any) => poi.idPoiServiceList.includes(s.id)).map((s: any) => getStatusLabelPoi(s.value)).join(', ') : ""}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('address')}
                            value={poi.address}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('city')}
                            value={poi.city ? poi.city : '--'}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('latitude')}
                            value={poi.latitude}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('longitude')}
                            value={poi.longitude}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                </Grid>
                {poi.poiTemplateDetailDTOList.length > 0 &&
                    <Grid container item rowSpacing={3} columnSpacing={3} xs={12} sx={{paddingTop: "50px"}}>
                        <Grid item xs={12}>
                            <Typography>{t('typeSection.title')}</Typography>
                        </Grid>
                        {poi.poiTemplateDetailDTOList.map((t: any, i: any) => {
                            switch (t.template) {
                                case POI_TYPE_TEMPLATE_EPLUS :
                                    return showTemplate1(t, i);
                                case POI_TYPE_TEMPLATE_DMS :
                                    return showTemplate2(t, i);
                                case POI_TYPE_TEMPLATE_ASSISTANCE :
                                    return showTemplate3(t, i);
                            }
                        })}
                    </Grid>
                }
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    )

    function showTemplate1(type: any, i: any) {
        return (
            <Grid item container xs={12}>
                <Paper elevation={3} sx={{width: "100%", padding: "16px", position: "relative", marginBottom: "10px"}}
                       key={i}>
                    <Grid item container xs={12} rowSpacing={3} columnSpacing={3}>
                        <Grid item xs={12}>
                            <Typography variant={'body1'}>{getStatusLabelPoi(type.template)}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('typeSection.chargingStationType')}
                                value={type.chargingStationType.length > 0 ? type.chargingStationType.join(', ') : ""}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }

    function showTemplate2(type: any, i: any) {
        return (
            <Grid item container xs={12}>
                <Paper elevation={3} sx={{width: "100%", padding: "16px", position: "relative", marginBottom: "10px"}}
                       key={i}>
                    <Grid item container xs={12} rowSpacing={3} columnSpacing={3}>
                        <Grid item xs={12}>
                            <Typography variant={'body2'}>{getStatusLabelPoi(type.template)}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.phoneNumber')}
                                value={type.phoneNumber}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.responsibleName')}
                                value={type.responsibleName}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.responsiblePhoneNumber')}
                                value={type.responsiblePhoneNumber}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.email')}
                                value={type.email}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.openingHours')}
                                value={type.openingHours}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.idDms')}
                                value={type.dmsId}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }

    function showTemplate3(type: any, i: any) {
        return (
            <Grid item container xs={12}>
                <Paper elevation={3} sx={{width: "100%", padding: "16px", position: "relative", marginBottom: "10px"}}
                       key={i}>
                    <Grid item container xs={12} rowSpacing={3} columnSpacing={3}>
                        <Grid item xs={12}>
                            <Typography variant={'body2'}>{getStatusLabelPoi(type.template)}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.assistanceTypeDetails')}
                                value={type.assistanceTypeDetail.length > 0 ? type.assistanceTypeDetail.map((it: any) => getStatusLabelPoi(it)).join(', ') : ''}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.assistanceBrands')}
                                value={type.brand.length > 0 ? type.brand.join(', ') : ''}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.openingHours')}
                                value={type.openingHours}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.bodyWorkName')}
                                value={type.bodyWorkName}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.phoneNumber')}
                                value={type.phoneNumber}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.email')}
                                value={type.email}
                                margin="dense"
                                variant="standard"
                                inputProps={
                                    {readOnly: true}
                                }
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }

}

export default PoiDetailModal;